<template>
  <div class="section-two">
    <div class="section-bg">
      <img src="@/assets/images/banner_2.jpg" alt />
    </div>
    <div class="container">
        <div class="container-img">
          <div class="con-img first">
            <img src="@/assets/images/image_5.png" alt="">
          </div>
          <div class="con-img second">
            <img src="@/assets/images/image_3.png" alt="">
          </div>
          <div class="con-img third">
            <img src="@/assets/images/image_4.png" alt="">
          </div>
          <div class="con-img fourth">
            <img src="@/assets/images/image_2.png" alt="">
          </div>
          <div class="con-img fifth">
            <img src="@/assets/images/image_1.png" alt="">
          </div>
        </div>
        <div class="container-footer">
          <div class="footer">
            <div class="icon">
              <img src="@/assets/images/icon_live.png" alt="">
            </div>
            <div class='icon-con'>
              <span>直播</span>
              <span>随时开播，让沟通更高效更简单</span>
            </div>
          </div>
          <div class="footer">
            <div class="icon">
              <img src="@/assets/images/icon_contribution.png" alt="">
            </div>
            <div class='icon-con'>
              <span>贡献值</span>
              <span>随时开播，让沟通更高效更简单</span>
            </div>
          </div>
          <div class="footer">
            <div class="icon">
              <img src="@/assets/images/icon_resources.png" alt="">
            </div>
            <div class='icon-con'>
              <span>资源</span>
              <span>整合资源，精准定位合作伙伴</span>
            </div>
          </div>
          <div class="footer">
            <div class="icon">
              <img src="@/assets/images/icon_administration.png" alt="">
            </div>
            <div class='icon-con'>
              <span>管理</span>
              <span>数字化管理，组织管理新变革</span>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class='sectionTwo'>第二屏内容</div> -->
  </div>
</template>

<script>
export default {
  name: "SectionTwo",
  methods: {
    afterLoad: function(anchorLink, index) {
      alert(index);
    }
  }
};
</script>

<style lang="css" scoped>
.section-two {
  color: #fff;
  position:relative;
  width:100%;
  height:100%;
  overflow:hidden;
}
.section-bg{
  position:absolute;
  left: 0 ;
  top:0;
  width:100%;
  height:100%;
}
.section-bg img{
  width:100%;
  height:100%;
}
.sectionTwo{
  position:absolute;
  top:50%;
  left: 50%;
  transform: translate(-50%,-50%);
  font-size:50px;
  color:#f00;
  opacity: 0.2;
  transition: color 1s opacity 1s;
  z-index: 1111;
}
.sectionTwo.current {
  font-size:100px;
  color:#0f0;
  opacity:1;
}
.container{
  width:100%;
  height:100%;
  box-sizing: border-box;
}
.container-img{
  width:100%;
  height:100%;
  display:flex;
  justify-content: space-around;
  align-items:center;
  position:absolute;
  left:50%;
  top: 0;
  transform:translateX(-50%);
  z-index:1;
}
.container-img .con-img{
  transition: transform 1s;
}
.container-img .con-img:nth-of-type(1){
  position:absolute;
  top:75px;
  left: 68px;
  z-index:11;
  transform: translate(-688px,-100px);
}
.container-img .con-img:nth-of-type(2){
  position:absolute;
  bottom:40px;
  left: 40px;
  transform: translate(-680px,300px);
  animation-delay:1s;
}
.container-img .con-img:nth-of-type(3){
  position:absolute;
  top:20%;
  left:50%;
  margin-left: -18%;
  transform:translate(-300px,-600px);
  z-index:5;
  animation-delay:2s;
}
.container-img .con-img:nth-of-type(4){
  position:absolute;
  bottom:35px;
  left: 42%;
  z-index:3;
  transform:translate(600px,600px);
  animation-delay:3s;
}
.container-img .con-img:last-child{
  width:460px;
  height:670px;
  position:absolute;
  right:6%;
  top:15%;
  transform:translate(600px,200px);
  animation-delay:4s;
}
.container-img .con-img{
  width:670px;
  height:460px;
}
.container-img.current .con-img{
  transform: none;
}
.container-img .con-img img{
  width:100%;
  height:100%;
}
.container .container-footer{
  width:100%;
  height:60px;
  background:#0e050a;
  opacity:.5;
  position:absolute;
  bottom:0;
  z-index:2;
  color:#fff;
  display:flex;
  justify-content: center;
  align-items:center;
}
.footer{
  flex: 0 0 1;
  height:100%;
  align-self:flex-start;
  display:flex;
  align-items:center;
  padding-left:111px;
  cursor: pointer;
}
.icon{
  padding-right:5px;
}
.icon img{
  width:36px;
  height:36px;
}
.icon-con{
  height:36px;
  display:flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left:5px;
  border-left:1px solid #fff;
}
.icon-con span{
  align-self:flex-start;
}
</style>
